import { z } from 'zod';
import { AGENT_DIFF_SECTIONS, EMAIL_DIFF_SECTIONS } from '../agent-diff/sections';
// An agent's changes as Via's cards show them, whether it compares two versions or makes an edit: the changes by
// area, the text each one touched cut to what reads well in a chat, and the flow and workflows as maps of their
// steps. The Versions tab has every word. Only schemas here, so the tool schemas can use them without loading the
// diff; shown-agent-changes.ts works them out.
const sectionIdSchema = z.enum([...AGENT_DIFF_SECTIONS, ...EMAIL_DIFF_SECTIONS].map(({ id }) => id));
const lineRowSchema = z.object({
    kind: z.enum(['same', 'added', 'removed', 'folded', 'more']),
    text: z
        .string()
        .describe('For a folded row, how many unchanged lines it stands for; for a more row, how many lines past what fits here')
});
const textChangeSchema = z.object({
    label: z.string(),
    before: z.string().optional().describe('The whole text before, when it is short; empty when it was added'),
    after: z.string().optional().describe('The whole text after, when it is short; empty when it was removed'),
    lines: z
        .array(lineRowSchema)
        .optional()
        .describe('For long text: only the lines that changed, with one line around each and the rest folded')
});
export const agentChangeSchema = z.object({
    id: z.string(),
    kind: z.enum(['added', 'removed', 'changed']),
    noun: z.string().describe('What sort of thing changed, such as Step, Action or Setting'),
    label: z.string(),
    parts: z.array(z.string()).describe('For a change inside something, the parts it touches'),
    texts: z.array(textChangeSchema)
});
const mapNodeSchema = z.object({
    id: z.string(),
    label: z.string(),
    kind: z.string().describe("A flow step's type, action, workflowStep, or formBlock"),
    app: z.string().optional(),
    action: z.string().optional(),
    depth: z.number(),
    status: z.enum(['added', 'removed', 'changed', 'same']),
    changeId: z.string().optional().describe('The change it shows, by id'),
    routes: z
        .array(z.object({ outcome: z.string(), to: z.string(), status: z.enum(['added', 'removed', 'same']) }))
        .optional()
        .describe("A flow step's outcomes and where each leads, when they changed"),
    gates: z
        .array(z.object({ text: z.string(), status: z.enum(['added', 'removed', 'same']) }))
        .optional()
        .describe('When a form block is asked, as it was and as it is')
});
export const agentChangeSectionSchema = z.object({
    id: sectionIdSchema,
    title: z.string(),
    changes: z.array(agentChangeSchema),
    map: z
        .array(mapNodeSchema)
        .optional()
        .describe('For the flow, the intake form, actions and workflows: their steps in order, each marked, for the card to draw')
});
/** What an edit changed, as its card shows it. */
export const agentChangesSchema = z.object({
    changeCount: z.number(),
    sections: z.array(agentChangeSectionSchema),
    textsLeftOut: z.number().optional()
});
//# sourceMappingURL=agent-change-schemas.js.map